module.exports = __webpack_public_path__ + "static/media/05.658e661e.png";